import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable( {
    providedIn: 'root'
} )
export class APIService {
    constructor( private http: HttpClient) { }

    httpOptions() {
        return {
            headers: new HttpHeaders( {
                'Content-Type': 'application/json; charset=UTF-8'
                }
            )};
    }

    getApiBaseUrl() {
        return environment.apiBaseUrl;
    }

    getAPI( endpoint: string ): Observable<any> {
        var url = `${this.getApiBaseUrl()}/${endpoint}`;
        return this.http.get( url, this.httpOptions(), );
    }

    postAPI( endpoint: string, payload: any ): Observable<any> {
        var url = `${this.getApiBaseUrl()}/${endpoint}`;
        return this.http.post( url, JSON.stringify( payload ), this.httpOptions() );
    }

    deleteByEndpointApi( endpoint: string ) {
        var url = `${this.getApiBaseUrl()}/${endpoint}`;
        return this.http.delete( url , this.httpOptions() );
    }
}
